import { httpClient } from '../httpClient';

export const notificationsApi = {
  getAll: () =>
    httpClient.get('/breach-notifications/all'),

  getBreaches: (params) =>
    httpClient.get('/breach-notifications/breaches', { params }),

  getBreachById: (id) =>
    httpClient.get(`/breach-notifications/breaches/${id}`),

  createBreach: (data) =>
    httpClient.post('/breach-notifications/breaches', data),

  updateBreach: (id, data) =>
    httpClient.put(`/breach-notifications/breaches/${id}`, data),

  deleteBreach: (id) =>
    httpClient.delete(`/breach-notifications/breaches/${id}`),

  getStakeholders: (params) =>
    httpClient.get('/breach-notifications/stakeholders', { params }),

  createStakeholder: (data) =>
    httpClient.post('/breach-notifications/stakeholders', data),

  updateStakeholder: (id, data) =>
    httpClient.put(`/breach-notifications/stakeholders/${id}`, data),

  deleteStakeholder: (id) =>
    httpClient.delete(`/breach-notifications/stakeholders/${id}`),

  send: (data) =>
    httpClient.post('/breach-notifications/send', data),

  getStats: () =>
    httpClient.get('/breach-notifications/stats'),

  generateDocument: (data) =>
    httpClient.post('/breach-notifications/generate-document', data, { responseType: 'blob' }),

  // ── System notifications — list & counts ──────────────────────────────
  list: ({ page = 1, perPage = 20, unreadOnly = false } = {}) => {
    const params = new URLSearchParams();
    if (page) params.set('page', String(page));
    if (perPage) params.set('per_page', String(perPage));
    if (unreadOnly) params.set('unread_only', 'true');
    const qs = params.toString();
    return httpClient.get(`/notifications/${qs ? `?${qs}` : ''}`);
  },

  getCount: () => httpClient.get('/notifications/count'),

  markAsRead: (notificationId) =>
    httpClient.post(`/notifications/${notificationId}/read`),

  markAllAsRead: () => httpClient.post('/notifications/read-all'),

  // ── Preferences (event × channel matrix) ──────────────────────────────
  getPreferences: () => httpClient.get('/notifications/preferences'),

  updatePreferences: (preferences) =>
    httpClient.put('/notifications/preferences', { preferences }),
};

export default notificationsApi;
